<script lang="ts" setup>
defineProps<{
  name: string
  label?: string
  description?: string
  placeholder?: string
  value?: string | number
}>()

// Make sure attributes not explicitly defined as props are passed to the inner component
// rather than the root element (which is the default behavior in Vue 3)
defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <UiFormField
    v-slot="{ componentField }"
    :name="name"
    keep-value
  >
    <UiFormItem>
      <UiFormLabel>{{ label }}</UiFormLabel>

      <UiFormControl>
        <UiInput
          v-bind="{ ...componentField, ...$attrs }"
          :key="name"
          :default-value="value"
          :placeholder="placeholder"
        />
      </UiFormControl>
      <UiFormDescription v-if="description || $slots.description">
        <slot name="description">
          {{ description }}
        </slot>
      </UiFormDescription>
      <UiFormMessage />
    </UiFormItem>
  </UiFormField>
</template>
